module.exports = __webpack_public_path__ + "static/img/搜索暂无icon@2x@3x.191ddf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/搜索暂无icon@2x@3x.png
// module id = F2ZU
// module chunks = 192